import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack } from '~/components/atomic';

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 100%;

  * {
    font-family: Poppins, 'serif';
  }
`;

export const Background = styled.div`
  position: relative;
  width: 100%;
  height: 80%;
  max-height: 800px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 40%,
      rgba(0, 0, 0, 0) 60%,
      rgba(0, 0, 0, 1) 100%
    );
  }
`;

export const DescriptionWrapper = styled(FlexStack)`
  ${({ theme }) => css`
    position: absolute;
    bottom: 5%;
    left: 0;
    width: 100%;
    padding: 0 ${theme.layout.section_side};
  `}
`;

export const DescBox = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 8px;

    strong {
      display: block;
      color: ${theme.always.label_white};
      font-size: 40px;
      font-weight: 700;
      line-height: 1.1;
    }

    span {
      ${theme.fontStyle.text.body18_medium}
      color: ${theme.content.content_light_3};
    }
  `}
`;

export const ButtonBox = styled.div`
  ${({ theme }) => css`
    display: block;
  `}
`;

export const Button = styled.button`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    height: 44px;
    border: 1px solid ${theme.stroke.stroke_2};
    border-radius: 22px;
    background: linear-gradient(90deg, #ffcc4a 0%, #ffe49f 100%);
    color: #462600;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -1%;
    line-height: 1.4;
    text-align: center;
  `}
`;
